import {defineAsyncComponent} from 'vue';

const GridErrorPopup = defineAsyncComponent(() => import('@/views/common/gridErrorPopup/GridErrorPopup.vue'));
const NPSForm = defineAsyncComponent(() => import('@/views/common/NPSForm.vue'));
const JusticeDecisionDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/justiceDecision/JusticeDecisionDetail.vue'),
);
const TransferExecutorDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/transferExecutor/TransferExecutorDetail.vue'),
);
const AccountingObjectQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/common/AccountingObjectQuickSearchPopup.vue'),
);
const JusticeDecisionQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/common/JusticeDecisionQuickSearchPopup.vue'),
);
const AreaQuickSearchPopup = defineAsyncComponent(() => import('@/views/common/AreaQuickSearchPopup.vue'));
const AssetCategoryQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/common/AssetCategoryQuickSearchPopup.vue'),
);
const AssetQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/common/AssetQuickSearchPopup.vue'),
);
const JusticeCaseQuickSearchPopup = defineAsyncComponent(() =>
  import('@/views/common/JusticeCaseQuickSearchPopup.vue'),
);

const ConfirmRedirectPopup = defineAsyncComponent(() => import('@/pages/ConfirmRedirectPopup.vue'));

const IncurredDataPopup = defineAsyncComponent(() => import('@/views/common/IncurredData/IncurredDataPopup.vue'));
// form show kết quả ghi sổ/ bỏ ghi sổ theo lô
const PostMultiResultPopup = defineAsyncComponent(() => import('@/views/common/postMultiResult/PostMultiResult.vue'));
const IncurredVoucherDataMultiple = defineAsyncComponent(() =>
  import('@/views/common/IncurredData/IncurredVoucherDataMultiple.vue'),
);
const CopyFromVoucherPopup = defineAsyncComponent(() => import('@/views/common/CopyFromVoucherPopup.vue'));
const CopyValueDetail = defineAsyncComponent(() => import('@/components/popup/CopyValueDetail.vue'));
const SendDigitalSignPopup = defineAsyncComponent(() => import('@/components/popup/SendDigitalSignPopup.vue'));
const RefuseSignPopup = defineAsyncComponent(() => import('@/components/popup/RefuseSignPopup.vue'));
const RevokeSignPopup = defineAsyncComponent(() => import('@/components/popup/RevokeSignPopup.vue'));
const RefuseApprovePopup = defineAsyncComponent(() => import('@/components/popup/RefuseApprovePopup.vue'));
const ProgressBatchSign = defineAsyncComponent(() => import('@/components/messageBox/MsProgressBatchSign.vue'));

const SignaturePaint = defineAsyncComponent(() =>
  import(/*webpackChunkName:'settinglayout'*/ '@/views/system/signingSetting/SignaturePaint.vue'),
);

export function registerCommonPopup(app) {
  app.component('GridErrorPopup', GridErrorPopup);
  app.component('NPSForm', NPSForm);
  app.component('JusticeDecisionDetail', JusticeDecisionDetail);
  app.component('TransferExecutorDetail', TransferExecutorDetail);
  app.component('AccountingObjectQuickSearchPopup', AccountingObjectQuickSearchPopup);
  app.component('JusticeDecisionQuickSearchPopup', JusticeDecisionQuickSearchPopup);
  app.component('AreaQuickSearchPopup', AreaQuickSearchPopup);
  app.component('AssetCategoryQuickSearchPopup', AssetCategoryQuickSearchPopup);
  app.component('AssetQuickSearchPopup', AssetQuickSearchPopup);
  app.component('JusticeCaseQuickSearchPopup', JusticeCaseQuickSearchPopup);
  app.component('ConfirmRedirectPopup', ConfirmRedirectPopup);
  app.component('IncurredDataPopup', IncurredDataPopup);
  app.component('PostMultiResult', PostMultiResultPopup);
  app.component('IncurredVoucherDataMultiple', IncurredVoucherDataMultiple);
  app.component('CopyFromVoucherPopup', CopyFromVoucherPopup);
  app.component('CopyValueDetail', CopyValueDetail);
  app.component('SendDigitalSignPopup', SendDigitalSignPopup);
  app.component('RefuseSignPopup', RefuseSignPopup);
  app.component('RevokeSignPopup', RevokeSignPopup);
  app.component('RefuseApprovePopup', RefuseApprovePopup);
  app.component('ProgressBatchSign', ProgressBatchSign);

  app.component('SignaturePaint', SignaturePaint);
}
